import { Epic } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, debounceTime, filter, map, mergeMap, pluck } from 'rxjs/operators'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'
import { track } from 'shared/store/actions/tracking'

import { CLUSTER, socketReconnect } from '@driftt/drift-ws'

import { isActionOf, RootAction, RootState, Services } from 'typesafe-actions'

import { fetchBootstrap } from './api'

export const fetchBootstrapEpic: Epic<RootAction, RootAction, RootState, Services> = (action$) => {
  return action$.pipe(
    filter(isActionOf(fetchBootstrapAsync.request)),
    mergeMap(() =>
      from(fetchBootstrap()).pipe(
        map(fetchBootstrapAsync.success),
        catchError((error: Error) => of(fetchBootstrapAsync.failure(error)))
      )
    )
  )
}

export const bootstrapOnReconnect: Epic<RootAction, RootAction, any, Services> = (action$) =>
  action$.pipe(
    filter(isActionOf(socketReconnect)),
    pluck('payload'),
    filter((cluster) => cluster === CLUSTER.CHAT),
    debounceTime(500), // avoid flapping connections
    mergeMap(() => [
      track({
        name: 'socketReconnect',
      }),
      fetchBootstrapAsync.request(),
    ])
  )
